// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"9e0e889b","62":"7b45cc58","162":"72f9ecb3","192":"a6beda44","379":"68eb248f","400":"ec2dd218","513":"01dd57fb","806":"0d622482","854":"cec66d4d","901":"abf324c1"}[chunkId] + ".chunk.js";
};